<script lang="ts">
    import { getContainer } from '$components/Context/ContainerContext';
    import { parse, serialize } from 'cookie';
    import { addYears, subYears } from 'date-fns';

    const { urlHelper, browser, parameters } = getContainer();

    let alreadyAccepted = getAlreadyAccepted();

    function getAlreadyAccepted() {
        if (browser() === false) {
            return true;
        }

        const parsed = parse(window?.document?.cookie);
        const serialized = parsed['goafrica.cookies-consent'] ?? null;
        return serialized === 'true';
    }

    function acceptCookies() {
        if (browser() === false) {
            return;
        }

        window.document.cookie = serialize('goafrica.cookies-consent', 'true', {
            domain: parameters.goafricaDomain,
            expires: addYears(new Date(), 1),
            path: '/',
        });

        alreadyAccepted = getAlreadyAccepted();
    }

    function rejectCookies() {
        if (browser() === false) {
            return;
        }

        for (const [key, _value] of Object.entries(
            parse(window?.document?.cookie ?? ''),
        )) {
            if (key !== 'GOAFRICA_NEXT_SESSION_ID' && key !== 'PHPSESSID') {
                document.cookie = serialize(key, '', {
                    domain: parameters.goafricaDomain,
                    expires: subYears(new Date(), 1),
                    path: '/',
                });
            }
        }
    }
</script>

{#if browser() && !alreadyAccepted}
    <div
        class="fixed bottom-0 left-0 right-0 z-[100] shadow-leo border-t border-t-gray-300 border-solid border-0 backdrop-blur-lg bg-gray-100/80"
    >
        <div
            class="container mx-auto p-10 flex flex-col ls:flex-row items-center justify-center gap-y-8 gap-x-16"
        >
            <p class="m-0 grow">
                Ce site utilise des cookies pour vous offrir le meilleur service ainsi que
                des publicités et contenu personnalisés.

                <br />
                <a href={urlHelper().politiqueConfidentialite()} target="_blank"
                    >En savoir plus</a
                >
            </p>

            <div class="flex flex-col ls:flex-row gap-4 w-full ls:w-auto">
                <a
                    on:click={() => rejectCookies()}
                    data-sveltekit-reload={true}
                    href={urlHelper().politiqueConfidentialite()}
                    class="btn-leo btn-leo-gray-blue"
                >
                    Refuser
                </a>
                <button
                    class="btn-leo btn-leo-blue px-24"
                    on:click|preventDefault={() => acceptCookies()}
                    >Accepter
                </button>
            </div>
        </div>
    </div>
{/if}
